import { render, staticRenderFns } from "./selfUpload.vue?vue&type=template&id=2764830b&scoped=true"
import script from "./selfUpload.vue?vue&type=script&lang=js"
export * from "./selfUpload.vue?vue&type=script&lang=js"
import style0 from "./selfUpload.vue?vue&type=style&index=0&id=2764830b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764830b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qjsz/develop/project/cc-shop-new/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2764830b')) {
      api.createRecord('2764830b', component.options)
    } else {
      api.reload('2764830b', component.options)
    }
    module.hot.accept("./selfUpload.vue?vue&type=template&id=2764830b&scoped=true", function () {
      api.rerender('2764830b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/selfUpload.vue"
export default component.exports